import { getGeoIPCountryCode } from './_utils';

/**
 * Hides Offer cards if the data-market attribute matches
 * the GEOIP cookie country code.
 * @return {null}
 */
export default function hideOfferCardByMarket() {
	const countryCode = getGeoIPCountryCode();

	// Select only offer cards with the data-market attribute.
	$('.OfferCard[data-market]').each((i, card) => {
		const market = $(card).data('market');

		if (!countryCode || countryCode.toUpperCase() !== market.toUpperCase()) {
			$(card).addClass('OfferCard--hidden');
		}
	});
}
